import React, { useEffect, useRef, useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import bootstrap5Plugin from "@fullcalendar/bootstrap5";
import api from "../../../apis/api";
import moment from "moment";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fullcalendar/bootstrap5/main.css";
import "@fullcalendar/daygrid/main.css";
import "../../../style/LeaderCalendar.css";
import interactionPlugin from "@fullcalendar/interaction";

const loginUser = JSON.parse(localStorage.getItem("user"));

const EmployeeCalendarView = () => {
  const calendarRef = useRef();
  const [calendarEvents, setCalendarEvents] = useState([]);
  const [leaveMap, setLeaveMap] = useState({});
  const [transactions, setTransactions] = useState([]);
  const [filterType, setFilterType] = useState("Me");
const [isCurrentMonth, setIsCurrentMonth] = useState(true);
const leaveTypeOptions = [
  { value: "Me", label: "Me" },
  { value: "My Organization", label: "My Organization" }
];
  useEffect(() => {
    loadCalendar();
  }, [filterType]);

  const loadCalendar = async () => {
    const res = await api.dbCalendarYear().GetAllPlannedLeaveAppply();
    let plannedLeaves = res.data || [];

    if (filterType === "Me") {
      plannedLeaves = plannedLeaves.filter(leave => leave.employeeId === parseInt(loginUser.EmployeeId));
    }

    const map = {};
    const events = [];

    plannedLeaves.forEach((leave) => {
      const from = moment(leave.fromDate);
      const to = moment(leave.toDate);

      let d = from.clone();
      while (d.isSameOrBefore(to)) {
        if (d.day() !== 0 && d.day() !== 6) {
          const key = d.format("YYYY-MM-DD");

          if (!map[key]) map[key] = [];
          map[key].push(leave);

          d.add(1, "day");
        } else d.add(1, "day");
      }
    });

    Object.keys(map).forEach((date) => {
      events.push({
        start: date,
        allDay: true,
        title: "",
        extendedProps: { count: map[date].length },
      });
    });

    setLeaveMap(map);
    setCalendarEvents(events);
  };

  return (
    <div className="container-fluid mt-3">
      <div className="d-flex justify-content-between mb-2">
        <h5>Leave Calendar</h5>
          <div style={{width:"200px"}}>
 <Select
  options={leaveTypeOptions}
  value={leaveTypeOptions.find(opt => opt.value === filterType)}
  onChange={(opt) => setFilterType(opt.value)}
  placeholder="Select Scope"
  isSearchable={false}
  menuPortalTarget={document.body}
  classNamePrefix="leave-select"
  style={{width: '200px'}}
/>
  </div>  
      </div>

      <div className="row">
        <div className="col-md-8">
          <FullCalendar
  ref={calendarRef}
     plugins={[dayGridPlugin, bootstrap5Plugin, interactionPlugin]}

  themeSystem="bootstrap5"
  initialView="dayGridMonth"
  events={calendarEvents}

  headerToolbar={{

    right: "todayBtn prev,next"
  }}

  customButtons={{

    todayBtn: {
      text: "Today",
      click: () => {
        calendarRef.current.getApi().today();
      }
    }
  }}
    datesSet={(arg) => {
    const current = moment();
    const viewDate = moment(arg.start);
    setIsCurrentMonth(
      current.month() === viewDate.month() &&
      current.year() === viewDate.year()
    );
  }}
      eventClick={(info) => {
    const key = moment(info.event.start).format("YYYY-MM-DD");
    const data = leaveMap[key] || [];
    setTransactions(data);

  }}
  

  eventContent={(arg) => (
    <div className="leave-count-circle">
      {arg.event.extendedProps.count}
    </div>
  )}
/>

        </div>

         <div className="col-md-4">
          <div className="leave-trans-card">
        
            <div className="leave-trans-header">
              <span>Leave Transactions ({transactions.length})</span>
        
              <div className="leave-trans-search">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search Employee"
                  onChange={(e) => {
                    const val = e.target.value.toLowerCase();
                   
                  }}
                />
                <i className="bi bi-search"></i>
              </div>
            </div>
        
            <table className="table table-sm leave-trans-table">
              <thead style={{background: '#e6f9f6ff'}}>
                <tr>
                  <th>Employee</th>
                  <th>Number of days</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {transactions.length === 0 && (
                  <tr><td colSpan="3" className="text-center text-muted">No records</td></tr>
                )}
        
                {transactions.map((t, i) => (
                  <tr key={i}>
                    <td>
                      <div className="emp-name">{t.employeeName}</div>
                      <div className="emp-role">{t.designation || ''}</div>
                    </td>
                 <td>{t.noOfDays == 1 ? "Full Day" : "Half Day"}</td>
            <td>{t.leaveStatus}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeCalendarView;
